<template>
  <div class="vt-date-picker">
    <date-picker
      ref="datePicker"
      v-model="date"
      :lang="lang"
      :type="type"
      :placeholder="format"
      :time-picker-options="timePickerOptions"
      :format="format"
      @clear="onClear()"
      @input="onInput($event)"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import DatePicker from 'vue2-datepicker'
import sessionStore from '@/session/sessionStore'
import { DateUtils } from '@/shared/util/date-utils'

export default Vue.extend({
    name: 'VtDatePicker',
    components: { DatePicker },
    data() {
        return {
            value: '',
            date: new Date()
        }
    },
    computed: {
        lang() {
            return sessionStore.getLocale()
        },
        timePickerOptions() {
            return {
                start: '00:00',
                step: '00:15',
                end: '23:45'
            }
        },
        type() {
            return this.params.filterParams.type
        },
        _pattern() {
            return this.type === 'datetime' ? DateUtils.localeDateTimePattern : DateUtils.localeDatePattern
        },
        format() {
            return this.params.filterParams.format ?? this._pattern
        }
    },
    methods: {
        focus() {
            this.$refs.datePicker.$refs.input.focus()
        },

        _parseDate(date) {
            return date?.toISOString() ?? ''
        },
        getDate() {
            return this.date
        },
        setDate(date) {
            this.date = date ?? null
            this.value = this._parseDate(date)
        },

        _onDateChanged(date) {
            this.setDate(date)
            this.params.onDateChanged()
        },
        onClear() {
            this._onDateChanged()
        },
        onInput(date) {
            if (this.value !== this._parseDate(date)) {
                this._onDateChanged(date)
            }
        }
    }
})
</script>

<style scoped lang="scss">
.vt-date-picker {
    ::v-deep .vdatetime {
        display: inline-block;
    }
}

.vt-date-picker-clear {
    margin-right: 5px;
    cursor: pointer;
}

.mx-datepicker{
    width: 100%;
}
</style>
